var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArmySeaDuty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 650,
    height: 250,
    viewBox: "0 0 650 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40_38)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 650,
    height: 250,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 250,
    fill: "#00155C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 592,
    width: 58,
    height: 250,
    fill: "#00155C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 0H138V250H58V0Z",
    fill: "#C0162D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 0H592V250H512V0Z",
    fill: "#C0162D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138 0H218V250H138V0Z",
    fill: "#D2C000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138 0H218V250H138V0Z",
    fill: "#D2C000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432 0H512V250H432V0Z",
    fill: "#D2C000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218,
    width: 35,
    height: 250,
    fill: "#26476C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253,
    width: 45,
    height: 250,
    fill: "#4A7FBC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352,
    width: 45,
    height: 250,
    fill: "#4A7FBC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397,
    width: 35,
    height: 250,
    fill: "#26476C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298 0H352V250H298V0Z",
    fill: "#790817"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317 0H332V250H317V0Z",
    fill: "#D2C000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40_38"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 650,
    height: 250,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArmySeaDuty);
export default __webpack_public_path__ + "static/media/Army Sea Duty.64850942ce902638e89fa707e6ac67e9.svg";
export { ForwardRef as ReactComponent };